import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DutyHolderDetail } from "../../Types/DutyHolderDetails/DutyHolderDetailsTypes";
import { getComplianceDeclarationFolderId } from "../../Thunks/BuildingInspectorThunks";

interface ComplianceDeclarationSliceState {
    loader: boolean; // for refres pages and inital loadings
    complianceDeclarationList: DutyHolderDetail [];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ComplianceDeclarationSliceState = {
    loader: false,
    complianceDeclarationList: [],
    errorDisplay: '',
}

// set state valu for api response
const complianceDeclarationSlice = createSlice ({
    name: 'complianceDeclarationSlice',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getComplianceDeclarationFolderId.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getComplianceDeclarationFolderId.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getComplianceDeclarationFolderId.fulfilled, (state, action: PayloadAction<DutyHolderDetail[]>) => {
                    state.loader = false;
                    state.complianceDeclarationList = action.payload;
                  })
    }
})

export const {} = complianceDeclarationSlice.actions
export default complianceDeclarationSlice.reducer
